import { Dropdown, Header, Input } from 'semantic-ui-react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	UpdateQuery,
	Initialize,
	Destroy,
} from '../../actions/overallsummary.actions';
import { AppState } from '../../types/app-state';
import { OverallSummaryReportState } from '../../types/overallsummaryreport-state';
import './OverallSummaryReportPage.less';

const monthOptions = [
	{ key: 'jan', value: 1, text: 'January' },
	{ key: 'feb', value: 2, text: 'February' },
	{ key: 'mar', value: 3, text: 'March' },
	{ key: 'apr', value: 4, text: 'April' },
	{ key: 'may', value: 5, text: 'May' },
	{ key: 'jun', value: 6, text: 'June' },
	{ key: 'jul', value: 7, text: 'July' },
	{ key: 'aug', value: 8, text: 'August' },
	{ key: 'sep', value: 9, text: 'September' },
	{ key: 'oct', value: 10, text: 'October' },
	{ key: 'nov', value: 11, text: 'November' },
	{ key: 'dec', value: 12, text: 'December' },
];

export const OverallSummaryReportPage: React.FC = () => {
	const dispatch = useDispatch();
	const { loading, data, month, year } = useSelector<
		AppState,
		Partial<OverallSummaryReportState>
	>((state) => state.overallsummary);
	const [state, setState] = useState({
		year: new Date().getFullYear(),
		delayId: 0,
	});

	const handleYearSelect = (event: any, data: any) => {
		if (state.delayId) {
			window.clearTimeout(state.delayId);
		}

		const delayId = window.setTimeout(() => {
			setState({ year: state.year, delayId: 0 });
			dispatch(UpdateQuery(undefined, +data.value));
		}, 500);

		setState({ year: +data.value, delayId });
	};

	const handleMonthSelect = (event: any, data: any) => {
		dispatch(UpdateQuery(+data.value, undefined));
	};

	useEffect(() => {
		dispatch(Initialize());
		dispatch(UpdateQuery(new Date().getMonth() + 1, new Date().getFullYear()));
		return () => {
			dispatch(Destroy());
		};
	}, [dispatch]);

	return (
		<div className='overallsummary-page'>
			<div />
			<Header as='h3' className='header'>
				<div>Overall Summary Report</div>
				<div className='inputs'>
					<Input
						autoFocus
						type='number'
						placeholder='Input Year'
						value={year}
						onChange={handleYearSelect}
					/>
					<Dropdown
						search
						selection
						placeholder='Select Month'
						value={month}
						onChange={handleMonthSelect}
						options={monthOptions}
					/>
				</div>
			</Header>
			{loading && <div className='loading-indicator'>Loading</div>}
			{!loading && (
				<table>
					<thead>
						<tr>
							<th>Organisation Name</th>
							<th>Total Participants</th>
							<th>New Participants</th>
							<th>Total Plans</th>
							<th>New Plans</th>
						</tr>
					</thead>
					{data && data.length > 0 && (
						<tbody>
							{data.map((item) => (
								<tr key={item.id}>
									<td>{item.org_name}</td>
									<td>{item.total_participants}</td>
									<td>{item.new_participants}</td>
									<td>{item.total_plans}</td>
									<td>{item.new_plans}</td>
								</tr>
							))}
						</tbody>
					)}
					{data && data.length === 0 && (
						<tbody>
							<tr>
								<td colSpan={5} style={{ textAlign: 'center' }}>
									No Data
								</td>
							</tr>
						</tbody>
					)}
				</table>
			)}
		</div>
	);
};

export default OverallSummaryReportPage;
